import React, {useMemo, CSSProperties} from 'react';
import {cn, toPriceStr} from '@utils';
import {LeaderboardItemType} from '@/common-pages/leaderboard/types';
import {Image} from 'antd-mobile';

interface TopItemType {
  crown: any;
  bg: any;
  rank: number;
  username: string;
  score?: number;
  avatar?: string;
  bonus?: number;
  point?: number;
  avatarStyle?: string;
  style: CSSProperties;
  rectStyle: string;
}

const topbg1 = require('../../assets/top-1-fission.webp');
const topbg2 = require('../../assets/top-2-fission.webp');
const topbg3 = require('../../assets/top-3-fission.webp');
const crown1 = require('../../assets/top-1-fission-bg.webp');
const crown2 = require('../../assets/top-2-fission-bg.webp');
const crown3 = require('../../assets/top-3-fission-bg.webp');
const defaultUser1 = require('../../assets/user-default-1.svg').default;
const defaultUser2 = require('../../assets/user-default-2.svg').default;
const defaultUser3 = require('../../assets/user-default-3.svg').default;
const defaultMap = new Map([
  [1, defaultUser1],
  [2, defaultUser2],
  [3, defaultUser3],
]);

const RANK_CONFIG: TopItemType[] = [
  {
    crown: crown2,
    bg: topbg2,
    rank: 2,
    username: '',
    avatarStyle: 'border-2 border-[#D1E0EE]',
    rectStyle: 'bg-gradient-to-r from-[#C3DAEE] to-[#5B7DA1]',
    style: {
      height: '13.6875rem',
      width: '8.1875rem',
      transform: 'translate(0,1.1875rem)',
      color: '#12385B',
      zIndex: 2,
    },
  },
  {
    crown: crown1,
    bg: topbg1,
    rank: 1,
    username: '',
    avatarStyle: 'border-2 border-[#F39E27]',
    rectStyle: 'bg-gradient-to-r from-[#FFCF6E] to-[#F8971F]',
    // rectStyle: 'bg-gradient-to-r from-[#FFCF6E] to-[#F8971F]',
    score: 10000,
    style: {
      height: '13.6875rem',
      width: '8.1875rem',
      color: '#975F0B',
      zIndex: 1,
    },
  },
  {
    crown: crown3,
    bg: topbg3,
    rank: 3,
    username: '',
    avatarStyle: 'border-2 border-[#FF9372]',
    rectStyle: 'bg-gradient-to-r from-[#FFC8B5] to-[#FF9263]',
    style: {
      height: '13.6875rem',
      width: '8.1875rem',
      transform: 'translate(-1.0rem,2.9375rem)',
      color: '#7F3115',
      zIndex: 3,
    },
  },
];

function FissionTop({data}: {data: LeaderboardItemType[]}) {
  const topThreeData = useMemo((): TopItemType[] => {
    const dataMap = new Map(data.map(item => [item.rank, item]));

    return RANK_CONFIG.map(item => {
      const matchedData = dataMap.get(item.rank);
      return matchedData
        ? {
            ...item,
            username: matchedData.username || item.username,
            avatar: matchedData.avatar,
            bonus: matchedData.bonus,
            point: matchedData.point,
          }
        : item;
    });
  }, [data]);
  const baseRect =
    'rounded w-[5.75rem] h-6 flex text-sm font-bold gap-1 items-center relative before:content-[""] before:absolute before:inset-0 before:rounded before:border before:border-[#FFFFFF26] before:pointer-events-none';

  return (
    <div className="relative flex justify-between mt-1">
      {topThreeData.map(item => {
        return (
          <div
            className={cn(
              'bg-full flex flex-col items-center text-[0.625rem] relative flex-shrink-0',
            )}
            key={item.rank}
            style={{
              backgroundImage: `url(${item.bg})`,
              ...item.style,
            }}>
            <div
              className={cn(
                item.avatarStyle,
                'rounded-full size-14 relative bg-full',
              )}
              style={{
                backgroundImage: `url(${
                  item.avatar || defaultMap.get(item.rank)
                })`,
              }}>
              <div
                className="size-6 bg-full absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2"
                style={{
                  backgroundImage: `url(${item.crown})`,
                }}></div>
            </div>

            <div
              className="text-t2 font-medium mt-6 mb-2.5 text-xs"
              style={{
                color: item.style.color,
              }}>
              {item.username || '--'}
            </div>
            <div className={cn(baseRect, item.rectStyle)}>
              <Image
                src={require('../../assets/person-shadow.webp')}
                className="w-5 h-4"></Image>
              <span>{item.point || '--'}</span>
            </div>
            <div className={cn(baseRect, item.rectStyle, 'mt-1')}>
              <Image
                src={require('../../assets/coin-shadow.webp')}
                className="w-5 h-4"></Image>
              {item.bonus
                ? toPriceStr(item.bonus, {
                    fixed: 0,
                    suffixUnit: 'K',
                    overPrice: 10000,
                  })
                : '--'}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default FissionTop;
